import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaMapMarkerAlt } from 'react-icons/fa';

function Hero() {
  return (
    <section id="home" className="hero-section">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} className="hero-content">
            <p className="text-uppercase mb-2" style={{ color: 'var(--accent)', fontWeight: 600, letterSpacing: '3px', fontSize: '0.85rem' }}>
              Full Stack Developer &amp; Solutions Architect
            </p>
            <h1 className="hero-name">
              Hi, I'm <span>John West</span>
            </h1>
            <p className="hero-tagline">
              Architecting solutions from front-end to back end — passionate about using technology to improve businesses in the web and ecommerce space.
            </p>
            <p className="hero-location">
              <FaMapMarkerAlt /> Alpharetta, Georgia, United States
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <Button
                href="#experience"
                variant="danger"
                size="lg"
                style={{ borderRadius: '50px', padding: '0.7rem 2rem', fontWeight: 600 }}
              >
                View My Work
              </Button>
              <Button
                href="#contact"
                variant="outline-light"
                size="lg"
                style={{ borderRadius: '50px', padding: '0.7rem 2rem', fontWeight: 600 }}
              >
                Get In Touch
              </Button>
            </div>
            <div className="hero-stats">
              <div className="hero-stat">
                <h3>30+</h3>
                <p>Years Experience</p>
              </div>
              <div className="hero-stat">
                <h3>50+</h3>
                <p>Enterprise Clients</p>
              </div>
              <div className="hero-stat">
                <h3>5</h3>
                <p>Books Published</p>
              </div>
            </div>
          </Col>
          <Col lg={5} className="text-center mt-5 mt-lg-0">
            <div className="hero-avatar">JW</div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Hero;
